var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroundColoured(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.9996,
    cy: 20.0001,
    r: 2.4,
    fill: "#F5DADF",
    stroke: "#2D2926",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.9996,
    cy: 29.6002,
    r: 2.4,
    fill: "#F5DADF",
    stroke: "#2D2926",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.4,
    cy: 26.6002,
    r: 2.4,
    fill: "#F5DADF",
    stroke: "#2D2926",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.6002,
    cy: 26.6002,
    r: 2.4,
    fill: "#F5DADF",
    stroke: "#2D2926",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.4,
    cy: 20.0001,
    r: 2.4,
    fill: "#F5DADF",
    stroke: "#2D2926",
    strokeWidth: 2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.6002,
    cy: 20.0001,
    r: 2.4,
    fill: "#F5DADF",
    stroke: "#2D2926",
    strokeWidth: 2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.6002,
    cy: 13.4,
    r: 2.4,
    fill: "#F5DADF",
    stroke: "#2D2926",
    strokeWidth: 2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.4,
    cy: 13.4,
    r: 2.4,
    fill: "#F5DADF",
    stroke: "#2D2926",
    strokeWidth: 2
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.4,
    cy: 4.4,
    r: 2.4,
    fill: "#F5DADF",
    stroke: "#2D2926",
    strokeWidth: 2
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.6002,
    cy: 4.4,
    r: 2.4,
    fill: "#F5DADF",
    stroke: "#2D2926",
    strokeWidth: 2
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.6002,
    cy: 13.4,
    r: 2.4,
    fill: "#F5DADF",
    stroke: "#2D2926",
    strokeWidth: 2
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.6002,
    cy: 26.6002,
    r: 2.4,
    fill: "#F5DADF",
    stroke: "#2D2926",
    strokeWidth: 2
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.6002,
    cy: 35.6002,
    r: 2.4,
    fill: "#F5DADF",
    stroke: "#2D2926",
    strokeWidth: 2
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.4,
    cy: 35.6002,
    r: 2.4,
    fill: "#F5DADF",
    stroke: "#2D2926",
    strokeWidth: 2
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.4,
    cy: 26.0001,
    r: 2.4,
    fill: "#F5DADF",
    stroke: "#2D2926",
    strokeWidth: 2
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.99961,
    cy: 13.4,
    r: 2.4,
    fill: "#F5DADF",
    stroke: "#2D2926",
    strokeWidth: 2
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.9996,
    cy: 10.4,
    r: 2.4,
    fill: "#F5DADF",
    stroke: "#2D2926",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroundColoured);
export default __webpack_public_path__ + "static/media/ground-coloured.6814a4fb91d113f0f59c7dc6ac655bca.svg";
export { ForwardRef as ReactComponent };